/**
 * Geographic Targeting Groups — client constants aligned with Cloud Functions
 * `geographicTargetingSyncShared.js`.
 *
 * Canonical Firestore fields:
 * - `geographicTargetingGroups`: array of { id, zipCodes, slides, targetAudience, maxCpcUsd, gtgType?, sponsorDisplayName | facilityDisplayName }
 *   (`gtgType`: optional `standard` | `symptom_checker`; omitted treated as standard)
 *   (`targetAudience`: patient | provider | facility; `maxCpcUsd` copied to zip listings as gtgMaxCpcUsd / gtgTargetAudience)
 * - `lastSyncedCarouselListings`: array of { listingDocId, zips, carouselListingOrder } (written by sync)
 *
 * Legacy flat `zipCodes` / `slides` / top-level display names are migrated on read;
 * saves should persist `geographicTargetingGroups` and clear legacy fields.
 */

export const GTG_DEFAULT_GROUP_ID = "default";

/** @type {string} */
export const GEOGRAPHIC_TARGETING_GROUPS_FIELD = "geographicTargetingGroups";

/** @type {string} */
export const LAST_SYNCED_CAROUSEL_LISTINGS_FIELD = "lastSyncedCarouselListings";
